document.addEventListener('DOMContentLoaded', function () {
  const forms = document.querySelectorAll('.gform_wrapper');

  forms.forEach(form => {
    const formIdMatch = form.id.match(/gform_wrapper_(\d+)/);
    if (!formIdMatch) return;

    const formId = parseInt(formIdMatch[1]);
    const pages = form.querySelectorAll('.gform_page');
    const pageCount = pages.length;
    if (pageCount < 2) return;

    const tracker = document.createElement('div');
    tracker.className = 'custom-step-tracker';

    const progressBar = document.createElement('div');
    progressBar.className = 'progress-fill';
    tracker.appendChild(progressBar);

    for (let i = 1; i <= pageCount; i++) {
      const step = document.createElement('div');
      step.className = 'step';
      step.textContent = String(i).padStart(2, '0');
      tracker.appendChild(step);
    }

    const actualForm = form.querySelector(`#gform_${formId}`);
    if (!actualForm) return;
    actualForm.prepend(tracker);

    let currentPage = 1;

    const updateSteps = (page) => {
      currentPage = page;

      const steps = tracker.querySelectorAll('.step');
      steps.forEach((s, idx) => {
        s.classList.remove('active', 'completed');
        if (idx + 1 < page) s.classList.add('completed');
        if (idx + 1 === page) s.classList.add('active');
      });

      let progress;
      if (page === pageCount) {
        progress = 1;
      } else {
        const baseProgress = (page - 1) / (pageCount - 1);
        const halfStep = 0.5 / (pageCount - 1);
        progress = baseProgress + halfStep;
      }

      if (progress === 1) {
        progressBar.style.width = '100%';
      } else {
        const trackWidth = tracker.clientWidth - 20;
        const stepWidth = steps[0].offsetWidth;
        const usableWidth = trackWidth - stepWidth;
        progressBar.style.width = (usableWidth * progress + stepWidth / 2) + 'px';
      }
    };

    // Gravity Forms page load event hook
    window.gform = window.gform || {};
    gform.addAction('gform_page_loaded', function (loadedFormId, page) {
      if (loadedFormId === formId) updateSteps(page);
    });

    // Confirmation detection via polling for confirmation wrapper visibility
    let confirmationCheckInterval = setInterval(() => {
      const confirmationWrapper = document.querySelector(`#gform_confirmation_wrapper_${formId}`);
      if (confirmationWrapper && confirmationWrapper.offsetParent !== null) {
        updateSteps(pageCount);
        clearInterval(confirmationCheckInterval);
      }
    }, 300);

    const initialPage = [...pages].findIndex(p => !p.hasAttribute('style') || p.style.display !== 'none') + 1;
    if (initialPage > 0) updateSteps(initialPage);

    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        updateSteps(currentPage);
      }, 100);
    });
  });
});
